import React from "react";
export const Footer = () => {
    return(
    <div className="footer">
            <center>
            
                &copy; {new Date().getFullYear()} Copyright: Team PDDA (Dipti Kasliwal, Swapnil V. Pawar, Rahul Virani, Swapnil R. Pawar) 
            
            </center>
    </div>
    );
};
